(() => {
  const innerHeader = document.querySelector('.aoma-header-section');
  const header = document.querySelector('#header-group > .aoma-header-sticky-section') || innerHeader?.closest('.shopify-section') || innerHeader;
  if (!header) return;

  const pageWrapper = document.querySelector('.page-wrapper');
  const getScrollY = () => Math.max(window.scrollY || 0, pageWrapper?.scrollTop || 0);

  const updateHeaderState = () => {
    header.classList.toggle('is-scrolled', getScrollY() > 12);
  };

  updateHeaderState();
  window.addEventListener('scroll', updateHeaderState, { passive: true });
  pageWrapper?.addEventListener('scroll', updateHeaderState, { passive: true });
})();
